import { render } from "./details.vue?vue&type=template&id=7652454e&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"

import "./details.vue?vue&type=style&index=0&id=7652454e&scoped=true&lang=css"

import exportComponent from "D:\\boya_project\\boya_web_mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7652454e"]])

export default __exports__